import React, { useState, useEffect, useContext, useCallback } from 'react'
import Sidedash from '../uicomponents/Sidedash';
import AlertContext from '../../context/AlertContext';
import { formatDate } from '../utils/Utilsfunc';

const Couponsall = () => {
    const host = process.env.REACT_APP_BACKEND_URL;
    const { showAlert } = useContext(AlertContext)
    const couponsdata = []
    const [coupons, setCoupons] = useState(couponsdata)
    const getAllCoupons = useCallback(async () => {
        try {
            const response = await fetch(`${host}/coupons/fetchcoupons`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': localStorage.getItem('token'),
                }
            })
            const json = await response.json();

            // Extract unique studentIds from coupons
            const studentIds = [...new Set(json.map(coupon => coupon.createdBy))];

            // Fetch all student data in one go
            const studentsResponse = await fetch(`${host}/students/showMultiple`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': localStorage.getItem('token'),
                },
                body: JSON.stringify({ ids: studentIds })
            });

            const studentsData = await studentsResponse.json();

            // Create a map for quick lookup
            const studentMap = studentsData.reduce((acc, student) => {
                acc[student._id] = student.name;
                return acc;
            }, {});

            // Combine coupons with student names
            const couponsWithStudent = json.map(coupon => ({
                ...coupon,
                studentName: studentMap[coupon.createdBy] || 'Unknown'
            }));


            setCoupons(couponsWithStudent)
        } catch (error) {
            console.error("Error fetching all coupons:", error)
        }
    }, [host])

    

    // toggle coupon status
    const toggleCouponStatus = async (couponId, currentStatus) => {
        try {
            const response = await fetch(`${host}/coupons/toggleStatus/${couponId}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': localStorage.getItem('token')
                },
                body: JSON.stringify({
                    couponStatus: !currentStatus,
                })
            })

            if (!response.ok) {
                throw new Error('Network response was not ok')
            }

            const responseData = await response.json();

            if (responseData.success) {
                setCoupons(coupons.map(coupon => {
                    if (coupon._id === couponId) {
                        return { ...coupon, isActive: !currentStatus };
                    }
                    return coupon
                }))
                showAlert("Coupon status changed", "success")
            } else {
                // Handle any error messages from the server
                console.error('Failed to update coupon status:', responseData.error);
            }

        } catch (error) {
            console.error('Error toggling coupon status:', error);
        }
    }


    // Delete a coupon
    const deleteCoupon = async (id) => {
        try {
            const response = await fetch(`${host}/coupons/delete/${id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": localStorage.getItem('token')
                }
            })
            const json = await response.json()
            if (response.ok) {
                const newCouponsData = coupons.filter(coupon => coupon._id !== id)
                showAlert("Coupon deleted!", "success")
                setCoupons(newCouponsData)
            } else {
                console.error("Failed to delete the coupon:", json);
            }

        } catch (error) {
            console.error("Error deleting coupon:", error)
        }

    }

    useEffect(() => {
        getAllCoupons();
    }, [getAllCoupons])

    return (
        <div className='container-fluid' style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
            <div className='row'>
                <Sidedash />
                <div className="col-md-9 pt-4 pb-5">
                    {/* Header Section */}
                    <div className="mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                                <h2 className="mb-1" style={{ fontWeight: '600', color: '#2c3e50' }}>Coupon Management</h2>
                                <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>Manage discount coupons and promotional codes</p>
                            </div>
                            <button 
                                className="btn btn-success" 
                                style={{ 
                                    padding: '0.6rem 1.5rem',
                                    borderRadius: '8px',
                                    fontWeight: '500',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    border: 'none'
                                }}
                            >
                                <span style={{ marginRight: '0.5rem' }}>+</span> Add Coupon
                            </button>
                        </div>
                    </div>

                    {/* Coupons Grid */}
                    <div className="row g-4">
                        {coupons.length === 0 && (
                            <div className="col-12">
                                <div className="alert alert-info" style={{ 
                                    borderRadius: '12px', 
                                    border: 'none',
                                    backgroundColor: '#e7f3ff',
                                    color: '#004085',
                                    padding: '1.5rem',
                                    textAlign: 'center'
                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-info-circle mb-2" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533z"/>
                                        <circle cx="8" cy="4.5" r="1"/>
                                    </svg>
                                    <div style={{ fontWeight: '500', fontSize: '1rem' }}>No coupons available!</div>
                                </div>
                            </div>
                        )}
                        {coupons.map((coupon) => {
                            const isExpired = coupon.expirationDate && new Date(coupon.expirationDate) < new Date();
                            const isLimitReached = coupon.usageLimit && coupon.timesUsed >= coupon.usageLimit;
                            
                            return (
                                <div key={coupon._id} className='col-md-6 col-lg-4 col-xl-4'>
                                    <div 
                                        className="card h-100" 
                                        style={{
                                            borderRadius: '16px',
                                            border: 'none',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                                            transition: 'all 0.3s ease',
                                            overflow: 'hidden',
                                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-4px)';
                                            e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
                                        }}
                                    >
                                        {/* Card Header */}
                                        <div className="card-body" style={{ padding: '1.5rem', color: 'white' }}>
                                            {/* Action Buttons */}
                                            <div className="d-flex justify-content-between align-items-start mb-3">
                                                <div 
                                                    className="badge" 
                                                    style={{ 
                                                        backgroundColor: coupon.isActive ? 'rgba(40, 167, 69, 0.9)' : 'rgba(108, 117, 125, 0.9)',
                                                        color: 'white',
                                                        padding: '0.4rem 0.8rem',
                                                        borderRadius: '8px',
                                                        fontSize: '0.75rem',
                                                        fontWeight: '600',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                    onClick={() => { toggleCouponStatus(coupon._id, coupon.isActive) }}
                                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                                >
                                                    {coupon.isActive ? '✓ Active' : '✕ Inactive'}
                                                </div>
                                                <div className="d-flex gap-2">
                                                    <button
                                                        className="btn btn-sm"
                                                        style={{
                                                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '6px',
                                                            padding: '0.3rem 0.6rem',
                                                            fontSize: '0.75rem',
                                                            fontWeight: '500',
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'}
                                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'}
                                                    >
                                                        ✏️ Edit
                                                    </button>
                                                    <button
                                                        className="btn btn-sm"
                                                        onClick={() => { deleteCoupon(coupon._id) }}
                                                        style={{
                                                            backgroundColor: 'rgba(220, 53, 69, 0.9)',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '6px',
                                                            padding: '0.3rem 0.6rem',
                                                            fontSize: '0.75rem',
                                                            fontWeight: '500',
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(200, 35, 51, 1)'}
                                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(220, 53, 69, 0.9)'}
                                                    >
                                                        🗑️ Delete
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Discount Display */}
                                            <div className="text-center mb-3">
                                                <div style={{ 
                                                    fontSize: '3rem', 
                                                    fontWeight: '700',
                                                    lineHeight: '1',
                                                    textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                }}>
                                                    {(coupon.discountType === "amount" ? "₹" : "") + coupon.discountValue + (coupon.discountType === "percentage" ? "%" : "")}
                                                </div>
                                                <div style={{ 
                                                    fontSize: '1.1rem', 
                                                    fontWeight: '500',
                                                    marginTop: '0.5rem',
                                                    opacity: '0.95'
                                                }}>
                                                    OFF
                                                </div>
                                            </div>

                                            {/* Description */}
                                            <div style={{ 
                                                textAlign: 'center',
                                                fontSize: '0.9rem',
                                                marginBottom: '1rem',
                                                minHeight: '2.5rem',
                                                opacity: '0.9'
                                            }}>
                                                {coupon.description || 'No description provided'}
                                            </div>

                                            {/* Coupon Code */}
                                            <div 
                                                style={{
                                                    background: 'rgba(255, 255, 255, 0.95)',
                                                    color: '#667eea',
                                                    padding: '0.75rem',
                                                    borderRadius: '10px',
                                                    textAlign: 'center',
                                                    fontWeight: '700',
                                                    fontSize: '1.1rem',
                                                    letterSpacing: '1px',
                                                    fontFamily: 'monospace',
                                                    border: '2px dashed rgba(102, 126, 234, 0.3)',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onClick={() => {
                                                    navigator.clipboard.writeText(coupon.code);
                                                    showAlert('Coupon code copied!', 'success');
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'scale(1.02)';
                                                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'scale(1)';
                                                    e.currentTarget.style.boxShadow = 'none';
                                                }}
                                                title="Click to copy"
                                            >
                                                {coupon.code}
                                            </div>
                                        </div>

                                        {/* Card Footer with Details */}
                                        <div 
                                            style={{
                                                backgroundColor: 'rgba(0, 0, 0, 0.15)',
                                                padding: '1rem 1.5rem',
                                                color: 'white'
                                            }}
                                        >
                                            <div className="d-flex flex-column gap-2" style={{ fontSize: '0.85rem' }}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span style={{ opacity: '0.9' }}>📊 Times Used:</span>
                                                    <span style={{ fontWeight: '600' }}>{coupon.timesUsed}</span>
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span style={{ opacity: '0.9' }}>🎯 Usage Limit:</span>
                                                    <span style={{ 
                                                        fontWeight: '600',
                                                        color: isLimitReached ? '#ffc107' : 'white'
                                                    }}>
                                                        {coupon.usageLimit === null ? "Unlimited" : coupon.usageLimit}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span style={{ opacity: '0.9' }}>🔒 Restriction:</span>
                                                    <span style={{ fontWeight: '600' }}>{coupon.productRestriction}</span>
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span style={{ opacity: '0.9' }}>📅 Expires:</span>
                                                    <span style={{ 
                                                        fontWeight: '600',
                                                        color: isExpired ? '#ffc107' : 'white'
                                                    }}>
                                                        {coupon.expirationDate === null ? "Never" : formatDate(coupon.expirationDate)}
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span style={{ opacity: '0.9' }}>👤 Created By:</span>
                                                    <span style={{ fontWeight: '600' }}>{coupon.studentName}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Couponsall